<template>
  <div class="program">
    <h2>互联网产品解决方案</h2>
    <p></p>
    <!-- <div class="resolve-tabs"> -->

    <div class="swiper-container myRow" ref="slider">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          :class="{ active: tabId == item.id }"
          v-for="(item, index) in tabsObj.leftList"
          :key="item.id"
          @click="changeTabs(item.id, index)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>

    <div
      :class="{ active: tabId == item.id }"
      :key="item.id"
      v-for="item in tabsObj.rightList"
      v-show="item.id == tabId"
      class="second-box"
    >
      <div class="swiper-container mySecond" ref="slider">
        <div class="swiper-wrapper">
          <div
            class="content-item swiper-slide"
            v-for="(s_item, s_index) in item.list"
            :key="s_index"
          >
            <div>
              <!-- <img :src="s_item.img" alt=""> -->
              <h2>{{ s_item.title }}</h2>
              <p>{{ s_item.desc }}</p>
              <div class="btn" @click="jumpDetail(s_item.id)">查看详情</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- </div> -->
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  props: {
    // tabsObj: {
    //   type:Object,
    //   default:()=>{}
    // },
  },
  data() {
    return {
      tabsObj: {
        leftList: [
          { id: 0, title: "电商系统解决方案" },
          { id: 1, title: "电商行业解决方案" },
          { id: 2, title: "体育行业解决方案" },
          { id: 3, title: "教育系统解决方案" },
          { id: 4, title: "智慧行业" },
        ],
        rightList: [],
        topList: [
          {
            select: 0,
            list: [
              {
                id: "supply",
                title: "S2B2B2C电商供应链系统",
                desc:
                  "构建完美企业级供应链电商体系解决实业+互联网困局为传统实业量身定做",
                url: "",
              },
              {
                id: "online",
                title: "B2B2C在线商城解决方案",
                desc:
                  "以丰富的营销功能，精细化的用户运营，解决多商城电商系统引流、推广难题，帮助企业打造生态级B2B2C多商城系统盈利模式",
                url: "",
              },
              {
                id: "self",
                title: "B2C自营品牌商城解决方案",
                desc:
                  "构建品牌商、零售商自己的多终端、全渠道线上零售商城助力企业快速进入电商新时代",
                url: "",
              },
              {
                id: "whole",
                title: "B2B批发商城系统",
                desc: "企业之间通过互联网为客提供更好的服务",
                url: "",
              },
              {
                id: "o2o",
                title: "O2O在线商城解决方案",
                desc:
                  "构建品牌商、零售商自己的多终端全渠道线上零售商城，助力企业快速进入电商新时代",
                url: "",
              },
              {
                id: "live",
                title: "直播电商解决方案",
                desc:
                  "将线下实体店转到线上，延续互联网优势解决实体店地域限制等难题",
                url: "",
              },
            ],
          },
          {
            select: 1,
            list: [
              {
                id: "mother",
                title: "母婴电商解决方案",
                desc:
                  "母婴零售商实现实体转型，打通母婴市场线上线下的全渠道服务，拉近和用户的距离",
                url: "",
              },
              {
                id: "fresh",
                title: "生鲜电商解决方案",
                desc:
                  "根据行业痛点，专注未生鲜企业提供完善、个性化、定制化的解决方案",
                url: "",
              },
              {
                id: "medicine",
                title: "医药电商解决方案",
                desc:
                  "为消费者提供医药一站式的网上电商平台，支持多个渠道购买，同时提供健康服务的在线支持",
                url: "",
              },
            ],
          },
          {
            select: 2,
            list: [{ id: "hall", title: "智慧售楼系统" }],
          },
          {
            select: 3,
            list: [
              {
                id: "fit",
                title: "健身场管理解决方案",
                desc:
                  "一套系统，打通健身房管理所有环节（降低管理成本，提高运营效率，提升品牌形象）",
                url: "",
              },
              {
                id: "move",
                title: "运动健身平台解决方案",
                desc:
                  "一套系统，打通健身房管理所有环节（降低管理成本，提高运营效率，提升品牌形象）",
                url: "",
              },
            ],
          },
          {
            select: 4,
            list: [
              {
                id: "new",
                title: "新教育解决方案",
                desc:
                  "可以自定义客户运营流程，基于客户的标签与行为，自动触发针对性的运营跟进流程。打通前后端系统工具，捕捉从注册到成单的行为闭环，识别关键行为，在合适的时机对客户进行转化。",
                url: "",
              },
              {
                id: "live",
                title: "直播课程解决方案",
                desc:
                  "以直播实时互动、点播资源沉淀为特色，为K12体制内管理者、教师、学生提供全方位的教学、管理和运营服务，使课内教学与课外学习融为一体。通过大数据分析进行诊断，为学生制定个性化的课程和学习路径，实现因材施教。重在培养学生自主学习的能力，最终实现个性化学习",
                url: "",
              },
            ],
          },
          {
            select: 5,
            list: [
              {
                id: "view",
                title: "智慧景区解决方案",
                desc:
                  "为景区建设一套线上、线下相结合的信息化综合服务系统，全面提升景区信息化水平，优化景区业务流程，提高运营管理效率，提升游客旅游体验；同时，利用大数据分析为景区的运行监控、旅游安全、应急智慧等方面提供数据依据",
                url: "",
              },
              { id: "travel", title: "智慧旅游解决方案", desc: "", url: "" },
              { id: "hotel", title: "智慧酒店解决方案", desc: "", url: "" },
            ],
          },
        ],
      },
      tabId: 4,
      secondSelect: "supply",
      allSelect: "system-supply",
      leftIndex: 0,
      rowSwiper: "",
      secondSwiper: "",
      // tabsObj: {},
    };
  },
  mounted() {
    let that = this;
    that.getTabsObj();
  },
  methods: {
    changeTabs(id, index) {
      if (this.tabId != id) {
        this.tabId = id;
      }
    },
    createSwiper() {
      this.secondSwiper = new Swiper(".mySecond", {
        observer: true,
        observeParents: true,
        slidesPerView: "auto", //1.5
        spaceBetween: 30,
        // width: 800,
        freeMode: false,
        loop: false,
        onReachEnd: function (swiper) {
          alert("到了最后一个slide");
        },
      });
      this.rowSwiper = new Swiper(".myRow", {
        slidesPerView: "auto", //2.2
        freeMode: false,
        loop: false,
      });
    },
    getTabsObj() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/productandsolve",
        null,
        (res) => {
          if (res.code == 1) {
            this.tabsObj = res.data.solveDown;
            this.$nextTick(() => {
              this.createSwiper();
            });
          }
        }
      );
    },
    jumpDetail(url) {
      this.$router.push("/m_solution/" + url);
    },
  },
  watch: {},
};
</script>
<style lang="stylus" scoped>
.program {
  h2 {
    text-align: center;
    margin-bottom: 0.48rem;
    font-size: 0.38rem;
    font-weight: 800;
    color: #333333;
    line-height: 0.28rem;
  }

  .myRow {
    width: 100%;

    >>>.swiper-slide {
      width: 200px;
      border-bottom: 1px solid #DBDBDB;
      font-size: 16px;
      font-weight: 500;
      color: #666666;
      padding: 0 0 14px 27px;
    }

    .swiper-slide.active {
      position: relative;
    }

    .swiper-slide.active::before {
      content: '';
      position: absolute;
      top: 28px;
      left: 40px;
      width: 100px;
      height: 2px;
      background: #FFC000;
      border-radius: 1px;
    }
  }

  .mySecond.swiper-container {
    margin-right: 0 !important;

    .swiper-wrapper {
      margin-left: 30px;
      margin-right: 30px;
    }

    .swiper-slide {
      width: 290px !important;
    }
  }

  .content-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 4%;
    margin-bottom: 10%;
    margin-right: 4%;
    height: 290px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(111, 111, 111, 0.1);
    border-radius: 5px;

    h2 {
      margin-top: 20px;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 20px;
    }

    p {
      text-align: center;
      width: 240px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }

    .btn {
      margin: 20px auto;
      text-align: center;
      line-height: 36px;
      width: 100px;
      height: 36px;
      background: #FFC000;
      border-radius: 5px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomeProgram.vue